import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../core/state/state';

import GlobalNotification from './global-notification/GlobalNotification';

import './GlobalNotifications.scss';

const GlobalNotifications: React.FC<any> = () => {
  const { globalNotifications } = useSelector((state: RootState) => state.globalNotifications);

  return (
    <div className="global-notifications">
      {globalNotifications.map((notification) => (
        <GlobalNotification key={notification.id} notification={notification} />
      ))}
    </div>
  );
};

export default GlobalNotifications;
